export default __webpack_public_path__ + "static/media/centerLocation.0c75b364.svg";